<div class="collaborateurs-section">
  <div class="loading-row" *ngIf="loading">
    <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
    <span>Chargement...</span>
  </div>

  <ng-container *ngIf="!loading">

   

    <mat-form-field appearance="outline" class="full-width" *ngIf="!readonly">
      <mat-label>Sélectionner les collaborateurs (actifs uniquement)</mat-label>
      <mat-select [formControl]="selectionControl" multiple>
        <mat-option *ngFor="let c of activeCollaborateurs" [value]="c.collabId">
          {{ c.nom }} {{ c.prenom }}
          <span *ngIf="c.postes?.length"> — {{ postesLabel(c) }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" *ngIf="!readonly" (click)="save()" [disabled]="saving">
      <mat-icon>save</mat-icon>
      Enregistrer l'association
    </button>

    <!-- Tableau récapitulatif des collaborateurs sélectionnés -->
    <div class="selected-table-wrapper" *ngIf="selectedCollaborateurs.length">

      <table class="selected-table mat-elevation-z2">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Prénom</th>
            <th>Poste(s)</th>
            <th class="cv-col">CV</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of selectedCollaborateurs">
            <td>{{ c.nom }}</td>
            <td>{{ c.prenom }}</td>
            <td>
              <span *ngIf="c.postes?.length; else noPoste">{{ postesLabel(c) }}</span>
              <ng-template #noPoste>—</ng-template>
            </td>
            <td class="cv-col">
              <button mat-icon-button
                      *ngIf="c.hasCv"
                      (click)="openCv(c)"
                      [disabled]="openingCvId === c.collabId"
                      matTooltip="Ouvrir le CV dans un nouvel onglet"
                      color="primary">
                <mat-icon *ngIf="openingCvId !== c.collabId">picture_as_pdf</mat-icon>
                <mat-spinner *ngIf="openingCvId === c.collabId" diameter="18"></mat-spinner>
              </button>
              <span *ngIf="!c.hasCv" class="no-cv">—</span>
            </td>
          </tr>
        </tbody>
      </table>

    </div>

    <div class="inactive-warning" *ngIf="inactiveAssociatedCollaborateurs.length">
      <mat-icon>info</mat-icon>
      <div>
        <div>Collaborateurs associés devenus inactifs (conservés dans l'historique du devis) :</div>
        <ul>
          <li *ngFor="let c of inactiveAssociatedCollaborateurs">{{ c.nom }} {{ c.prenom }}</li>
        </ul>
      </div>
    </div>

  </ng-container>

</div>